import LaunchIcon from '@mui/icons-material/Launch'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import { formatDate } from '@util/date-util'

import { StyledIconLink } from '../../theme/components/StyledIconLink'
import type { ProjectmeldingenSearchResult } from '../types/ProjectmeldingSearchResult'

interface Props {
  projectmelding: ProjectmeldingenSearchResult
}

export const ProjectmeldingenTableRow = ({ projectmelding }: Props) => {
  const {
    id,
    numberOfObjects,
    companyName,
    projectName,
    projectCity,
    created,
    status,
    tags,
  } = projectmelding

  return (
    <TableRow key={id}>
      <TableCell>{projectName}</TableCell>
      <TableCell>{status?.name && status.name}</TableCell>
      <TableCell>{companyName}</TableCell>
      <TableCell>{numberOfObjects}</TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {tags.map((tag) => {
            return <Chip key={tag} size="medium" label={tag} />
          })}
        </Box>
      </TableCell>
      <TableCell>{formatDate(created)}</TableCell>
      <TableCell>{projectCity}</TableCell>
      <TableCell>
        <StyledIconLink
          title={`Navigeer naar vooraanmelding: ${projectName}`}
          icon={<LaunchIcon />}
          href={`/vooraanmelding/${projectmelding.id}`}
        />
      </TableCell>
    </TableRow>
  )
}
